import { DragDropModule }        from '@angular/cdk/drag-drop';
import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { BookingDiaryComponent }                 from './booking-diary.component';
import { BookingDiaryAppointmentModalComponent } from './booking-diary.appointment-modal.component';
import { BookingDiaryBookingModalComponent }     from './booking-diary.booking-modal.component';
import { BookingDiaryEventChipComponent }        from './booking-diary.event-chip.component';
import { BookingDiaryFoldToggleComponent }       from './booking-diary.fold-toggle.component';
import { BookingDiaryListComponent }             from './booking-diary.list.component';
import { BookingDiaryMonthGridComponent }        from './booking-diary.month-grid.component';
import { BookingDiarySelectedComponent }         from './booking-diary.selected.component';
import { BookingDiaryStartJobsModalComponent }   from './booking-diary.start-jobs-modal.component';
import { BookingDiaryStates }                    from './booking-diary.states';
import { BookingDiaryTimeGridComponent }         from './booking-diary.time-grid.component';
import { BookingDiaryUnassignedRailComponent }   from './booking-diary.unassigned-rail.component';
import { JobStatusBookingPipe }                  from '../transaction-center/jobs/transaction-center.jobs.status-booking.pipe';
import { SharedModule }                          from '../shared/shared.module';

@NgModule({
  declarations: [
    BookingDiaryComponent,
    BookingDiaryAppointmentModalComponent,
    BookingDiaryBookingModalComponent,
    BookingDiaryEventChipComponent,
    BookingDiaryFoldToggleComponent,
    BookingDiaryListComponent,
    BookingDiaryMonthGridComponent,
    BookingDiarySelectedComponent,
    BookingDiaryStartJobsModalComponent,
    BookingDiaryTimeGridComponent,
    BookingDiaryUnassignedRailComponent
  ],
  entryComponents: [
    BookingDiaryAppointmentModalComponent,
    BookingDiaryBookingModalComponent,
    BookingDiaryComponent,
    BookingDiaryStartJobsModalComponent
  ],
  providers: [
    JobStatusBookingPipe
  ],
  imports: [
    DragDropModule,
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: BookingDiaryStates })
  ]
})
export class BookingDiaryModule {}
